"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringFunctions = void 0;
var replaceAll = function (str, original, replacement) {
    return str.split(original).join(replacement);
};
exports.stringFunctions = {
    capitalize: function (alterVal) {
        return alterVal && alterVal.charAt(0).toUpperCase() + alterVal.slice(1);
    },
    replaceAll: replaceAll,
    replacementMap: function (str, map) {
        for (var _i = 0, _a = Object.keys(map); _i < _a.length; _i++) {
            var key = _a[_i];
            str = replaceAll(str, key, map[key]);
        }
        return str;
    },
    sentenceCase: function (alterVal) {
        return alterVal && alterVal.charAt(0).toUpperCase() + alterVal.slice(1).toLowerCase();
    }
};
//# sourceMappingURL=strings.js.map